/** Formato monetario / fechas unificado para ficha financiera del préstamo (4I). */

export function moneyAr(value: unknown): string {
  const n = Number(value ?? 0);
  if (!Number.isFinite(n)) return '—';
  return n.toLocaleString('es-AR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}

/** Convención producto: `$1.500.000,00` (sin espacio, alineado a LoanDetail histórico). */
export function formatMoneyAr(value: unknown): string {
  const formatted = moneyAr(value);
  if (formatted === '—') return '—';
  return `$${formatted}`;
}

/** Fecha de negocio DD/MM/YYYY (acepta YYYY-MM-DD o ISO). */
export function formatBusinessDate(value?: string | Date | null): string {
  if (!value) return '—';
  if (typeof value === 'string' && /^\d{4}-\d{2}-\d{2}/.test(value)) {
    const [y, m, d] = value.slice(0, 10).split('-');
    return `${d}/${m}/${y}`;
  }
  const d = typeof value === 'string' ? new Date(value) : value;
  if (Number.isNaN(d.getTime())) return String(value).slice(0, 10);
  return d.toLocaleDateString('es-AR');
}

export function formatDateTimeAr(value?: string | Date | null): string {
  if (!value) return '—';
  const d = typeof value === 'string' ? new Date(value) : value;
  if (Number.isNaN(d.getTime())) return '—';
  return d.toLocaleString('es-AR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
}
